const EXPECTED_WITHIN_MS = 500;

let expectedUntil = 0;

/**
 * Call just before clicking a download link. Chromium counts a click on a
 * cross-origin attachment as a navigation and fires `beforeunload`, though the
 * page stays. WebKit fires nothing, so the expectation also has to run out by
 * itself. A blob link never navigates, so it sets nothing.
 */
export function expectDownloadNavigation(url: string): void {
  if (url.startsWith('blob:')) return;
  expectedUntil = Date.now() + EXPECTED_WITHIN_MS;
}

export function consumeDownloadNavigation(): boolean {
  const isExpected = Date.now() <= expectedUntil;
  expectedUntil = 0;
  return isExpected;
}
